import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  OnDestroy,
  Output
} from '@angular/core'

import { LanguageCode } from '../../common/generated-types'
import { DataService } from '../../data/providers/data.service'
import { LocalStorageService } from '../../providers/local-storage/local-storage.service'
import { map } from 'rxjs/operators'
import { gql } from 'apollo-angular'

const GET_PROFILE_ADMIN_ESCAPE = gql`
  query GetProfileAdminEscape {
    profileMerchantManager {
      id
      name
      email
      phone
      address
      positionInSystem
      createdAt
      updatedAt
      isAdmin
      imageUrl
      imageId
      merchantId
      hotelId
      venueId
      userId
      baseId
      merchantType
      merchant {
        businessName
        representative
        taxCode
        email
        businessCode
        contactPerson
        contactPhone
      }
      merchant_venue_id
    }
  }
`

interface ProfileResponse {
  profileMerchantManager: {
    id: string
    name: string
  }
}

export const GET_PROFILE = gql`
  query GetProfile {
    profileMerchantManager {
      id
      name
      positionInSystem
      merchantType
    }
  }
`
@Component({
  selector: 'vdr-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent implements OnInit, OnDestroy {
  @Input() userId = ''
  @Input() availableLanguages: LanguageCode[] = []
  @Input() uiLanguageAndLocale: [LanguageCode, string | undefined]
  @Output() logOut = new EventEmitter<void>()
  @Output() selectUiLanguage = new EventEmitter<void>()

  userName = ''
  userAvatar = ''

  constructor(
    private dataService: DataService,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit() {
    this.loadProfileFromLocalStorage()
    // Listen for storage changes to update profile when it changes
    window.addEventListener('storage', this.handleStorageChange.bind(this))
  }

  ngOnDestroy() {
    window.removeEventListener('storage', this.handleStorageChange.bind(this))
  }

  private handleStorageChange() {
    this.loadProfileFromLocalStorage()
  }

  /**
   * Public method to refresh profile data from local storage
   */
  refreshProfile(): void {
    this.loadProfileFromLocalStorage()
  }

  private loadProfileFromLocalStorage(): void {
    const userProfile = this.localStorageService.get('userProfile')
    if (userProfile && userProfile.name) {
      this.userName = userProfile.name
      this.userAvatar = userProfile.imageUrl || ''
    } else {
      // Clear any existing data if no profile found
      this.userName = ''
      this.userAvatar = ''

      // Check if user is logged in by checking for administratorId
      const currentAdminId = this.localStorageService.get('currentAdminId')
      if (currentAdminId) {
        // Fetch profile directly
        this.dataService
          .query<any>(GET_PROFILE_ADMIN_ESCAPE)
          .mapStream((data) => data.profileMerchantManager)
          .subscribe({
            next: (profile) => {
              if (profile) {
                this.localStorageService.set('userProfile', profile)
                this.userName = profile.name
                this.userAvatar = profile.imageUrl || ''
              }
            },
            error: (error) => {
              console.error('User menu - failed to fetch profile:', error)
            }
          })
      }
    }
  }
}
